module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "move"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlag),
      expression: "showFlag"
    }],
    ref: "food",
    staticClass: "food"
  }, [_c('div', {
    staticClass: "food-content"
  }, [_c('div', {
    staticClass: "image-header"
  }, [_c('img', {
    attrs: {
      "src": _vm.food.image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "back",
    on: {
      "click": _vm.hide
    }
  }, [_c('i', {
    staticClass: "icon icon-arrow_lift"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.food.name))]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('span', {
    staticClass: "sell-count"
  }, [_vm._v(_vm._s(_vm.$t("sellcount")) + _vm._s(_vm.food.sellCount))]), _vm._v(" "), _c('span', {
    staticClass: "rating"
  }, [_vm._v(_vm._s(_vm.$t("rating")) + _vm._s(_vm.food.rating) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "now"
  }, [_vm._v(_vm._s(_vm.food.price) + " €")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.food.oldPrice),
      expression: "food.oldPrice"
    }],
    staticClass: "old"
  }, [_vm._v(_vm._s(_vm.food.oldPrice) + " €")])]), _vm._v(" "), _c('div', {
    staticClass: "cartcontrol-wrapper"
  }, [_c('cartcontrol', {
    attrs: {
      "food": _vm.food
    },
    on: {
      "cartAdd": _vm.addFood
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.food.count),
      expression: "!food.count"
    }],
    staticClass: "buy",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.addFirst($event)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("addtocart")) + "\n          ")])])], 1), _vm._v(" "), _c('split', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.food.info),
      expression: "food.info"
    }]
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.food.info),
      expression: "food.info"
    }],
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("productinfo")))]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.food.info))])]), _vm._v(" "), _c('split')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cf60cb6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/food/food.vue
// module id = 471
// module chunks = 1